import { useState } from "react";
import { useAsyncEffect } from "use-async-effect";
import { isWebcamSupportedWithDocker } from "../../../utils/userAgentUtils";
import { isBrowserPermissionGranted } from "../../../utils/toolbarItemUtils";

// TODO [LOWA-30534] From: https://tiny.amazon.com/yadspity
export const useCheckWebcamModal = () => {
    const [showWebcamModal, setShowWebcamModal] = useState(false);
    const [isWebcamModalReady, setIsWebcamModalReady] = useState(false);
    useAsyncEffect(async () => {
        setIsWebcamModalReady(false);

        const getWebCamModalState = async () => {
            if (!isWebcamSupportedWithDocker()) {
                // Early exit before async checking
                return false;
            }
            if (await isBrowserPermissionGranted("camera")) {
                // Webcam permission granted
                return false;
            }
            return true;
        };

        try {
            const needToShowWebCamModal = await getWebCamModalState();
            setShowWebcamModal(needToShowWebCamModal);
        } catch {
            // Failed to check webcam modal state. Move to next step.
        }

        setIsWebcamModalReady(true);
    }, []);

    return {
        showWebcamModal,
        hideWebcamModal: () => setShowWebcamModal(false),
        isWebcamModalReady,
    };
};
